import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)(
  ({ theme }) => `
    flex: 1;
    min-height: 0;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    ${theme.breakpoints.up('md')} {
        flex-direction: row;
    }`,
);

export const FixedWidthColumn = styled(Box)(
  ({ theme }) => `
    ${theme.breakpoints.up('md')} {
        width: 300px;
        margin-top: 20px;
        padding-right: 0.625rem;
        flex-shrink:0;
    }`,
);

export const FluidWidthColumn = styled(Box)`
  flex: 1;
  overflow: hidden;
`;

export const Container = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
`;

export const CardGridWrapper = styled(Box)`
  height: 100%;
  overflow-y: auto;
`;
